"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as o } from "react";
import t from "../components/Icon/SvgIcon.js";
const l = (e) => /* @__PURE__ */ a(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...e,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.25 4.884A1.63 1.63 0 0 1 4.873 3.25h14.232a1.63 1.63 0 0 1 1.623 1.634v14.232a1.63 1.63 0 0 1-1.623 1.634H4.873a1.63 1.63 0 0 1-1.623-1.634zM4.873 22h14.232a2.88 2.88 0 0 0 2.873-2.884V4.884A2.88 2.88 0 0 0 19.105 2H4.873A2.88 2.88 0 0 0 2 4.884v14.232A2.88 2.88 0 0 0 4.873 22m7.41-14.304h.083c2.78.111 4.976 2.363 4.976 5.144 0 1.5-.64 2.919-1.78 3.892-1.111.973-2.613 1.418-4.113 1.223C8.918 17.621 6.97 15.342 7 12.784a6.6 6.6 0 0 1 .25-1.474.25.25 0 0 1 .167-.166c.056-.028.084-.028.139-.028.028 0 .083 0 .111.028l.974.389a.31.31 0 0 1 .166.39c-.11.416-.166.833-.11 1.25.139 1.502 1.278 2.808 2.752 3.115a3.44 3.44 0 0 0 2.92-.724 3.49 3.49 0 0 0 1.278-2.697 3.497 3.497 0 0 0-3.281-3.475h-.084v1.196a.6.6 0 0 1-.306.528.6.6 0 0 1-.61 0L8.112 9.114a.6.6 0 0 1-.305-.528c0-.222.11-.417.305-.528l3.254-1.975a.6.6 0 0 1 .61 0 .6.6 0 0 1 .306.529z",
        clipRule: "evenodd"
      }
    )
  }
), c = o(l);
export {
  c as ResetAppData,
  c as default
};
